export const PATHS = {
  ROOT: 'part-time-jobs',
  PUBLIC: 'part-time-jobs/public',
  LIKED: 'part-time-jobs/liked',
  getOneById: (id: number) => `${PATHS.ROOT}/${id}`,
  getAllByCompanyId: (id: number) => `company/${id}/${PATHS.ROOT}`,
  getPublicId: (id: number) => `${PATHS.PUBLIC}/${id}`,
};
